import DropdownCommon, {
  DropdownItemStyled,
} from 'components/common/DropdownCommon';
import { EN_LANG, I18N_REDIRECTED } from 'constants';
import { Fade } from 'helpers/animation';
import Cookies from 'helpers/cookies';
import useAuth from 'hooks/useAuth';
import useFirebase from 'hooks/useFirebase';
import useLang from 'hooks/useLang';
import useQuery from 'hooks/useQuery';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const LANGUAGE_REFERENCE = {
  en: { nativeName: 'English' },
  vi: { nativeName: 'Tiếng Việt' },
};

export const LANGUAGE_NAME = 'language-field';

const CustomLangDropdown = ({ styles = {} }) => {
  const { locate } = useLang();
  const query = useQuery();
  const { isRemoxTheme } = useTheme();
  const { state } = useStore();
  const { currentUser } = state || {};
  const { token } = useAuth();
  const { saveDeviceToken } = useFirebase();

  const [isShowDropdown, setShowDropdown] = useState(false);

  const [currentLang, setCurrentLang] = useState(EN_LANG);

  const setLanguage = (lang) => {
    i18next.changeLanguage(lang);

    setCurrentLang(lang);

    Cookies.set(I18N_REDIRECTED, lang);
  };

  useEffect(() => {
    if (isRemoxTheme) {
      setLanguage(EN_LANG);

      return;
    }

    const lang = query.get('lang');
    if (lang) {
      setLanguage(lang);
    } else {
      setLanguage(locate);
    }
  }, [isRemoxTheme, locate, query]);

  const remainingLanguage = Object.keys(LANGUAGE_REFERENCE)?.find(
    (lang) => lang !== currentLang
  );

  const handleChangeLanguage = async (lang) => {
    setLanguage(lang);

    setShowDropdown(false);

    if (Notification?.permission === 'granted' && currentUser) {
      saveDeviceToken({ token, isActive: true, lang });
    }
  };

  const handleDropdownOnToggle = () => {
    setShowDropdown(!isShowDropdown);
  };

  const renderDropdownMenuChildren = () => (
    <DropdownItemStyled
      eventKey={remainingLanguage}
      onClick={() => handleChangeLanguage(remainingLanguage)}
      style={{
        borderRadius: '8px',
        justifyContent: 'center',
      }}
    >
      {LANGUAGE_REFERENCE[remainingLanguage].nativeName}
    </DropdownItemStyled>
  );
  const getStyleDropdown = () => ({
    width: '55px',
    border: 'none',
  });
  const getStyleDropdownToggle = () => ({
    padding: 0,
    paddingRight: '32px',
    borderRadius: 0,
    svgFilter: 'var(--ds-f-c-white)',
    color: 'var(--ds-c-white)!important',
    colorHover: 'var(--ds-c-white)!important',
  });
  const getStyleDropdownMenu = () => ({
    borderRadius: '8px',
    background: '#fff',
    minWidth: '100px',
    minHeight: '40px',
    transform: 'translate(-45px, 45px)',
  });

  return (
    <LanguageDropdownStyled $isHidden={isRemoxTheme} style={{ ...styles }}>
      <DropdownCommon
        value={currentLang}
        isShowDropdown={isShowDropdown}
        onToggle={handleDropdownOnToggle}
        renderDropdownMenuChildren={renderDropdownMenuChildren}
        styleDropdown={getStyleDropdown()}
        styleDropdownToggle={getStyleDropdownToggle()}
        styleDropdownMenu={getStyleDropdownMenu()}
      />
    </LanguageDropdownStyled>
  );
};

const LanguageDropdownStyled = styled.div`
  display: ${(props) => (props.$isHidden ? 'none' : 'flex')};
  align-items: center;
  margin-right: 2px;
  ${Fade};
  @media screen and (min-width: 1280px) {
    margin-left: 40px;
  }
`;

export default CustomLangDropdown;
